/**
 * Prefills Wematik contact / shipping forms from URL query params.
 * Safe to load on all pages (no-ops when the fields are missing).
 *
 * Examples:
 *   /pages/kontakt?anliegen=Beratung
 *   /pages/kontakt?betreff=Service
 *   /pages/kontakt?anliegen=Versandkosten&artikel=WHM31
 */
(function () {
  var params = new URLSearchParams(window.location.search);

  function firstParam(names) {
    for (var i = 0; i < names.length; i++) {
      var raw = params.get(names[i]);
      if (raw != null && String(raw).trim() !== '') return String(raw).trim();
    }
    return null;
  }

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/[&+]/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function matchOption(select, wanted) {
    var wantedN = normalize(wanted);
    if (!wantedN) return null;
    var options = Array.prototype.slice.call(select.options);
    var exact = options.filter(function (opt) {
      return normalize(opt.value) === wantedN || normalize(opt.textContent) === wantedN;
    })[0];
    if (exact) return exact;
    return options.filter(function (opt) {
      var valueN = normalize(opt.value);
      var textN = normalize(opt.textContent);
      return (valueN && (valueN.indexOf(wantedN) !== -1 || wantedN.indexOf(valueN) !== -1))
        || (textN && (textN.indexOf(wantedN) !== -1 || wantedN.indexOf(textN) !== -1));
    })[0] || null;
  }

  function ensureOption(select, label) {
    var match = matchOption(select, label);
    if (match) return match;
    var opt = document.createElement('option');
    opt.value = label;
    opt.textContent = label;
    select.appendChild(opt);
    return opt;
  }

  function fillField(el, value) {
    if (!el || value == null) return;
    if (el.tagName === 'SELECT') {
      var match = matchOption(el, value);
      if (!match && /versand/i.test(value)) match = ensureOption(el, 'Versandkosten');
      if (match) el.value = match.value || match.textContent;
    } else {
      el.value = value;
    }
    el.dispatchEvent(new Event('change', { bubbles: true }));
    el.dispatchEvent(new Event('input', { bubbles: true }));
  }

  var betreff = firstParam(['anliegen', 'betreff', 'subject', 'topic', 'form_source']);
  var artikel = firstParam(['artikel', 'article', 'sku', 'inquiry']);
  var land = firstParam(['land', 'country']);
  var plz = firstParam(['plz', 'postleitzahl', 'zip']);

  if (betreff) {
    var selects = document.querySelectorAll('select#anliegen, select[name="anliegen"], select[id*="betreff"], select[name*="betreff"], select[id*="anliegen"], select[name*="anliegen"]');
    Array.prototype.forEach.call(selects, function (select) {
      fillField(select, betreff);
    });
  }

  if (artikel) {
    ['#artikel', '[name="artikel"]', '#inquiry', '[name="inquiry"]', '[name="contact[Artikel]"]', '[data-fill-from-param]'].forEach(function (sel) {
      if (sel === '[data-fill-from-param]') {
        document.querySelectorAll('[data-fill-from-param]').forEach(function (el) {
          var names = String(el.getAttribute('data-fill-from-param') || '').toLowerCase();
          if (/artikel|article|sku|inquiry/.test(names) && el.tagName !== 'SELECT') fillField(el, artikel);
        });
        return;
      }
      fillField(document.querySelector(sel), artikel);
    });
  }

  var produkt = firstParam(['produkt', 'product']);
  if (produkt) {
    fillField(document.querySelector('[name="contact[Produkt]"]'), produkt);
  }

  if (land) fillField(document.querySelector('select#land, select[name="land"]'), land);
  if (plz) fillField(document.querySelector('#plz, #postleitzahl, [name="plz"], [name="postleitzahl"]'), plz);
})();
